import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AuthProvider } from './auth/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import { queryClient } from './lib/query';
import { logFrontendError } from './lib/errorLog';
import { ToastContainer } from './lib/toast';
import { ConfirmDialogHost } from './lib/confirm';
import './styles.css';

// Rede de segurança para erros fora do ciclo React/React Query (ex.: exceção
// síncrona em um setTimeout, promise rejeitada sem .catch).
window.addEventListener('error', (event) => {
  logFrontendError('window', { message: event.message, filename: event.filename, lineno: event.lineno }, event.error ?? event.message);
});
window.addEventListener('unhandledrejection', (event) => {
  logFrontendError('unhandled-rejection', {}, event.reason);
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <App />
            <ToastContainer />
            <ConfirmDialogHost />
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
);
